import axios from "@/components/api/axios";

async function getContent(id) {
  const queryId = id ? `id=${id}` : "";
  const res = await axios.axiosGet(
    `/api/fanClub/leaders/getContent?${queryId}`
  );
  return res;
}

export default {
  getContent
};



// WEBPACK FOOTER //
// ./src/components/api/fanClub/leaders/leadersMemberDetail.js